export default __webpack_public_path__ + "30b151b30ddabdc28339ef64c1befcc5.png";